/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './EyebrowMessageDataServiceEntities.g';

// @ts-ignore
function availablePromotionsDescriptionsQuery(itemId?: string): DataServiceQuery {
    const key = itemId ? { ItemId: itemId } : null;
    return new DataServiceQuery('AvailablePromotionsDescriptions', 'MFIPromotion', DataServiceEntities.MFIPromotionExtensionClass, key);
}

export function createMFIGetAvailablePromotionsDescriptionInput(
    queryResultSettings: IQueryResultSettings,
    availablePromotionsDescription: DataServiceEntities.IMFIAvailablePromotionDescription
): IDataServiceRequest {
    const query = availablePromotionsDescriptionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'MFIGetAvailablePromotionsDescription',
        true,
        DataServiceEntities.MFIPromotionExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIPromotion' },
        { availablePromotionsDescription: availablePromotionsDescription }
    );
}

export function mFIGetAvailablePromotionsDescriptionAsync(
    context: IContext,
    availablePromotionsDescription: DataServiceEntities.IMFIAvailablePromotionDescription
): AsyncResult<DataServiceEntities.IMFIPromotion[]> {
    const request = createMFIGetAvailablePromotionsDescriptionInput(context.queryResultSettings || {}, availablePromotionsDescription);
    return callActionOrExecute<DataServiceEntities.IMFIPromotion[]>(request, context.callerContext);
}
